import { lazy } from "react";



const Pos = lazy(() => import("./Pos"));

const Open = lazy(() => import("./OpenClose/Open"));

const Close = lazy(() => import("./OpenClose/Close"));

const CashOutExternIdent = lazy(() => import("./CashOut/CashOutExternIdent"));

const CashOutExtern = lazy(() => import("./CashOut/CashOutExtern"));

const CheckDepositExternIdent = lazy(() => import("./CheckDeposit/CheckDepositExternIdent"));

const CheckDepositExtern = lazy(() => import("./CheckDeposit/CheckDepositExtern"));

const SearchStock = lazy(() => import("./SearchStock/SearchStock"));

const CashOut = lazy(() => import("./CashOut/CashOut"));

const CheckDeposit = lazy(() => import("./CheckDeposit/CheckDeposit"));

const Consulter = lazy(() => import("./Objectif/Consulter/Consulter"));

const Attribuer = lazy(() => import("./Objectif/Attribuer/Attribuer"));

const BaseArticles = lazy(() => import("./BaseArticle/BaseArticles"));

const StockArticles = lazy(() => import("./StockArticles/StockArticles"));

const ArticleDetailsPos = lazy(() => import("./BaseArticle/Components/ArticleDetailsPos"));

const AutoReassortParentPos = lazy(() => import("./BaseArticle/Components/AutoReassortParentPos"));

const HistoriqueClient = lazy(() => import("./Historique/HistoriqueClient"));

const HistoriqueVente = lazy(() => import("./Historique/HistoriqueVente"));

const HistoriqueCommande = lazy(() => import("./Historique/HistoriqueCommande"));

const HistoriqueDevis = lazy(() => import("./Historique/HistoriqueDevis"));

const HistoriquePreparation = lazy(() => import("./Historique/HistoriquePreparation"));

const ActivityReport = lazy(() => import("./ActivityReport/ActivityReport"));

const PeripheriquePos = lazy(() => import("./Peripherique/PeripheriquePos"));

const TransferOrderPos = lazy(() => import("./TransferOrder/TransferOrderPos"));

const TransferOrderDetailPos = lazy(() => import("./TransferOrder/TransferOrderDetailPos"));

const PurchaseOrderPos = lazy(() => import("./PurchaseOrder/PurchaseOrderPos"));

const PurchaseOrderDetailPos = lazy(() => import("./PurchaseOrder/PurchaseOrderDetailPos"));

const ClotureDetail = lazy(() => import("./ClotureDetail/ClotureDetail"));

const InventairePos = lazy(() => import("./InventairePos/InventairePos"));

const CategoryInventoryPos = lazy(() => import("./InventairePos/Comp/CategoryInventoryPos"));

const CategoryInventoryPosScanMasse = lazy(() => import("./InventairePos/Comp/CategoryInventoryPosScanMasse"));

const ZoneInventoryPos = lazy(() => import("./InventairePos/Comp/ZoneInventoryPos"));

const BinsInventoryPos = lazy(() => import("./InventairePos/Comp/BinsInventoryPos"));

const BinsInventoryPosScan = lazy(() => import("./InventairePos/Comp/BinsInventoryPosScan"));

const ZoneInventoryPosScan = lazy(() => import("./InventairePos/Comp/ZoneInventoryPosScan"));

const NotificationListPos = lazy(() => import("./Notification/NotificationListPos"));

const NotificationDetailPos = lazy(() => import("./Notification/NotificationDetailPos"));

const LicenceNotificationDetail = lazy(() => import("../notifications/LicenceNotificationDetail"));

const AutoRestockPos = lazy(() => import("./AutoRestockPos/AutoRestockPos"));

const RestockDetail = lazy(() => import("./AutoRestockPos/Comp/RestockDetail"));

const PosReport = lazy (()=> import("./ReportPbi/PosReport"))

const ListeArticleTablePos = lazy (()=> import("./ListeArticle/ListeArticleTablePos"))

const DetailListeArticleTablePos = lazy (()=> import("./ListeArticle/DetailListeArticleTablePos"))

const AbonnementCardListErp = lazy(() => import("../erp/AbonnementCard/AbonnementCardListErp"));



/**********!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!***************** */

/*     Toutes les routes POS doivent commencer par pos/:posid            */

/*     A part la route d'ouverture et de cloture de caisse               */

/**********!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!***************** */

const posBaseRoutes = [
    // ─── Ouverture / clôture de caisse ─────────────────────────────────────────
    {
        path: "/openpos/:posid",
        id: "pos_open",
        name: "[POS] Ouverture de caisse - /openpos/:posid",
        component: Open
    },
    {
        path: "/cloturepos/:posid",
        id: "pos_close",
        name: "[POS] Clôture de caisse - /cloturepos/:posid",
        component: Close
    },
    // ─── Caisse ────────────────────────────────────────────────────────────────
    {
        exact:true,
        path: "/pos/:posid",
        id: "pos_home",
        name: "[POS] Caisse - /pos/:posid",
        component: Pos
    },
    // ─── Articles : recherche stock, base articles, stock ──────────────────────
    {
        path: "/pos/:posid/searchstock/:reference?",
        id: "pos_search_stock",
        name: "[POS] Recherche de stock - /pos/:posid/searchstock/:reference?",
        component: SearchStock
    },
    {
        exact:true,
        path: "/pos/:posid/item-base",
        id: "pos_item_base",
        name: "[POS] Base articles - /pos/:posid/item-base",
        component: BaseArticles
    },
    {
        path: "/pos/:posid/item-base/details/:id",
        id: "pos_item_base_details",
        name: "[POS] Détail article (base articles) - /pos/:posid/item-base/details/:id",
        component: ArticleDetailsPos
    },
    {
        path: "/pos/:posid/automatic-restock/parent-item/:id",
        id: "pos_auto_restock_parent_item",
        // name: "[POS] Réassort auto - article parent - /pos/:posid/automatic-restock/parent-item/:id",
        component: AutoReassortParentPos
    },
    {
        exact:true,
        path: "/pos/:posid/stock-item",
        id: "pos_stock_item",
        name: "[POS] Stock par article - /pos/:posid/stock-item",
        component: StockArticles
    },
    // ─── Objectifs & CA ────────────────────────────────────────────────────────
    {
        path: "/pos/:posid/objectif",
        id: "pos_objectif",
        name: "[POS] Objectifs et CA - /pos/:posid/objectif",
        component: Consulter
    },
    {
        path: "/pos/:posid/rhobjectif",
        id: "pos_rh_objectif",
        // name: "[POS] Attribution des objectifs - /pos/:posid/rhobjectif",
        component: Attribuer
    },
    // ─── Retraits d'espèces & dépôts de chèques ────────────────────────────────
    {
        path: "/pos/:posid/cashout",
        id: "pos_cashout",
        name: "[POS] Retrait d'espèces - /pos/:posid/cashout",
        component: CashOut
    },
    {
        path: "/pos/:posid/check-deposit",
        id: "pos_check_deposit",
        name: "[POS] Dépôt de chèques - /pos/:posid/check-deposit",
        component: CheckDeposit
    },
    {
        exact:true,
        path: "/cashout/:posid",
        id: "pos_cashout_extern_ident",
        name: "[POS] Retrait d'espèces externe - identification - /cashout/:posid",
        component: CashOutExternIdent
    },
    {
        exact:true,
        path: "/cashout/:posid/:caisse_ident_id",
        id: "pos_cashout_extern",
        // name: "[POS] Retrait d'espèces externe - /cashout/:posid/:caisse_ident_id",
        component: CashOutExtern
    },
    {
        exact:true,
        path: "/checkdeposit/:posid",
        id: "pos_check_deposit_extern_ident",
        // name: "[POS] Dépôt de chèques externe - identification - /checkdeposit/:posid",
        component: CheckDepositExternIdent
    },
    {
        exact:true,
        path: "/checkdeposit/:posid/:caisse_ident_id",
        id: "pos_check_deposit_extern",
        // name: "[POS] Dépôt de chèques externe - /checkdeposit/:posid/:caisse_ident_id",
        component: CheckDepositExtern
    },
    {
        exact:true,
        path: "/cloture-detail/:posnum/:depotBanque",
        id: "pos_cloture_detail",
        // name: "[POS] Détail de clôture - /cloture-detail/:posnum/:depotBanque",
        component: ClotureDetail
    },
    // ─── Historiques ───────────────────────────────────────────────────────────
    {
        path: "/pos/:posid/sales-historical",
        id: "pos_sales_historical",
        name: "[POS] Historique des ventes - /pos/:posid/sales-historical",
        component: HistoriqueVente
    },
    {
        path: "/pos/:posid/customer-historical/:client_id?",
        id: "pos_customer_historical",
        name: "[POS] Historique client - /pos/:posid/customer-historical/:client_id?",
        component: HistoriqueClient
    },
    {
        path: "/pos/:posid/sales-order-historical",
        id: "pos_sales_order_historical",
        name: "[POS] Historique des commandes - /pos/:posid/sales-order-historical",
        component: HistoriqueCommande
    },
    {
        path: "/pos/:posid/quotation-historical",
        id: "pos_quotation_historical",
        name: "[POS] Historique des devis - /pos/:posid/quotation-historical",
        component: HistoriqueDevis
    },
    {
        path: "/pos/:posid/preparation-historical",
        id: "pos_preparation_historical",
        // name: "[POS] Historique des préparations - /pos/:posid/preparation-historical",
        component: HistoriquePreparation
    },
    // ─── État de caisse ────────────────────────────────────────────────────────
    {
        path: "/pos/:posid/activity-report",
        id: "pos_activity_report",
        name: "[POS] État de caisse - /pos/:posid/activity-report",
        component: ActivityReport
    },
    // ─── Divers : périphériques ────────────────────────────────────────────────
    {
        path: "/pos/:posid/peripherals",
        id: "pos_peripherals",
        // name: "[POS] Périphériques - /pos/:posid/peripherals",
        component: PeripheriquePos
    },
    // ─── Divers : bons de commande ─────────────────────────────────────────────
    {
        exact:true,
        path: "/pos/:posid/purchase-order",
        id: "pos_purchase_order",
        name: "[POS] Bons de commande - /pos/:posid/purchase-order",
        component: PurchaseOrderPos
    },
    {
        exact:true,
        path: "/pos/:posid/purchase-order-detail/:poId",
        id: "pos_purchase_order_detail",
        name: "[POS] Détail bon de commande - /pos/:posid/purchase-order-detail/:poId",
        component: PurchaseOrderDetailPos
    },
    // ─── Divers : ordres de transfert ──────────────────────────────────────────
    {
        exact:true,
        path: "/pos/:posid/transfer-order",
        id: "pos_transfer_order",
        name: "[POS] Ordres de transfert - /pos/:posid/transfer-order",
        component: TransferOrderPos
    },
    {
        exact:true,
        path: "/pos/:posid/transfer-order-detail/:toId",
        id: "pos_transfer_order_detail",
        name: "[POS] Détail ordre de transfert - /pos/:posid/transfer-order-detail/:toId",
        component: TransferOrderDetailPos
    },
    // ─── Divers : inventaire ───────────────────────────────────────────────────
    {
        exact:true,
        path: "/pos/:posid/inventory",
        id: "pos_inventory",
        name: "[POS] Inventaire - /pos/:posid/inventory",
        component: InventairePos
    },
    {
        exact:true,
        path: "/pos/:posid/inventory/categorie/:id/:zoneid",
        id: "pos_inventory_category",
        name: "[POS] Inventaire par catégorie - /pos/:posid/inventory/categorie/:id/:zoneid",
        component: CategoryInventoryPos
    },
    {
        exact:true,
        path: "/pos/:posid/inventory/categorie/:id/:zoneid/:rhid",
        id: "pos_inventory_category_scan_masse",
        // name: "[POS] Inventaire par catégorie - scan de masse - /pos/:posid/inventory/categorie/:id/:zoneid/:rhid",
        component: CategoryInventoryPosScanMasse
    },
    {
        exact:true,
        path: "/pos/:posid/inventory/zone/:id/:zoneid",
        id: "pos_inventory_zone",
        name: "[POS] Inventaire par zone - /pos/:posid/inventory/zone/:id/:zoneid",
        component: ZoneInventoryPos
    },
    {
        exact:true,
        path: "/pos/:posid/inventory/zone/:id/:zoneid/:zoneinventoryid/:rhid",
        id: "pos_inventory_zone_scan",
        // name: "[POS] Inventaire par zone - scan - /pos/:posid/inventory/zone/:id/:zoneid/:zoneinventoryid/:rhid",
        component: ZoneInventoryPosScan
    },
    {
        exact:true,
        path: "/pos/:posid/inventory/bins/:id/:zoneid",
        id: "pos_inventory_bins",
        name: "[POS] Inventaire par bin - /pos/:posid/inventory/bins/:id/:zoneid",
        component: BinsInventoryPos
    },
    {
        exact:true,
        path: "/pos/:posid/inventory/bins/:id/:zoneid/:binsinventoryid/:binsid/:binsnum/:rhid",
        id: "pos_inventory_bins_scan",
        // name: "[POS] Inventaire par bin - scan - /pos/:posid/inventory/bins/:id/:zoneid/:binsinventoryid/:binsid/:binsnum/:rhid",
        component: BinsInventoryPosScan
    },
    // ─── Divers : listes d'articles ────────────────────────────────────────────
    {
        exact:true,
        path: "/pos/:posid/items-list",
        id: "pos_items_list",
        name: "[POS] Listes d'articles - /pos/:posid/items-list",
        component: ListeArticleTablePos
    },
    {
        exact:true,
        path: "/pos/:posid/items-list/:id",
        id: "pos_items_list_detail",
        name: "[POS] Détail liste d'articles - /pos/:posid/items-list/:id",
        component: DetailListeArticleTablePos
    },
    // ─── Divers : réassort interne ─────────────────────────────────────────────
    {
        path: "/pos/:posid/auto-restock",
        id: "pos_auto_restock",
        name: "[POS] Réassort interne - /pos/:posid/auto-restock",
        component: AutoRestockPos
    },
    {
        path: "/pos/:posid/auto-restock-details/:id",
        id: "pos_auto_restock_details",
        name: "[POS] Détail réassort interne - /pos/:posid/auto-restock-details/:id",
        component: RestockDetail
    },
    // ─── Divers : rapport & cartes d'abonnement ────────────────────────────────
    {
        exact:true,
        path: "/pos/:posid/report",
        id: "pos_report",
        // name: "[POS] Rapport Power BI - /pos/:posid/report",
        component: PosReport
    },
    {
        exact:true,
        path: "/pos/:posid_url/abonnementcard",
        id: "pos_abonnementcard",
        // name: "[POS] Cartes d'abonnement - /pos/:posid_url/abonnementcard",
        component: AbonnementCardListErp
    },
    // ─── Notifications (hors menu) ─────────────────────────────────────────────
    {
        path: "/pos/:posid/notifications/list",
        id: "pos_notifications_list",
        // name: "[POS] Liste des notifications - /pos/:posid/notifications/list",
        component: NotificationListPos
    },
    {
        path: "/pos/:posid/notifications/detail/:id",
        id: "pos_notifications_detail",
        // name: "[POS] Détail notification - /pos/:posid/notifications/detail/:id",
        component: NotificationDetailPos
    },
    {
        path: "/pos/:posid/notifications/licence-notification/:licenceNotificationId",
        id: "pos_notifications_licence_detail",
        // name: "[POS] Détail notification licence - /pos/:posid/notifications/licence-notification/:licenceNotificationId",
        component: LicenceNotificationDetail
    },
];

export default posBaseRoutes;
